import React, { Component, PropTypes } from "react";
import styled from "styled-components";

import { NitroIcon } from "nitro-components";

import DriverListItem from "./DriverListItem";

const TableOverflowWrapper = styled.div`
  margin-top: 40px;
  overflow: auto;
  position: relative;
`;

const TableContainer = styled.div`
   overflow-x: auto;
   height:500px;
  -ms-overflow-style: none;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  -webkit-overflow-scrolling: touch;
`;

const TableView = styled.table`
  display: table;
  border-collapse: inherit;
`;

const TableHead = styled.thead`
  display: block;
  width: 700px;
  overflow: visible;
  margin-left: 30px;
`;

const TableRow = styled.tr``;

const TableHeader = styled.th`
  min-width: ${props => (props.merged ? "300px" : "200px")};
  height: 40px;
  color: ${props => (props.disabled ? props.theme.color.base2 : props.theme.color.white)};
  border-right: 5px solid ${props => props.theme.color.white};
  background-color: ${props => (props.disabled ? props.theme.color.base3 : props.theme.color[props.variant])};
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  z-index: 5;

  > div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 10px;
  }
  span {
    min-width: 142px;
  }

  &:nth-child(1) {
    color: ${props => props.theme.color.white};
    line-height: 40px;
    display: block;
    min-width: 300px;
    border-left: 0px;
    background-color: ${props => props.theme.color.secondary};
  }

  ${props => props.fixed && `
    position: relative;
    top: 0;
    left: 0;
  `}
`;

const TableBody = styled.tbody`
  display: block; /*seperates the tbody from the header*/
  width: 1100px;
  min-height: 300px;
  z-index: 5;
  margin-left: 30px;
`;

const TableBodyRow = styled.tr``;

const TableColumn = styled.td`
  background-color: ${props => props.theme.color.white};
  min-width: ${props => (props.merged ? "300px" : "200px")};
  text-align: center;
  border-bottom: 1px solid ${props => props.theme.color.border};
  z-index: 5;
  height: 54px;

  &:nth-child(1) {
    min-width: 300px;
  }

  ${props => props.fixed && `
    position: relative;
    left: 0;
    height: 54px;
  `}
`;

const ClickableElement = styled.div`
    padding: 0 20px;
`;

const ClickElementContent = styled.section`
  background:  #F7F7F7;
  display:flex;
  flex-direction: row;
  border-radius: 100px;
  padding: 2px 10px;
  justify-content: space-around;

  > div {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    cursor: pointer;

    span {
     min-width: 120px;
     padding: 0 20px;
    }

    span.negative {
       color: ${props => props.theme.color.negative};
    }
  }
`;

const PlaceholderValue = styled.section`
  background: ${props => props.theme.color.base2};
  opacity: 0.1;
  border-radius: 100px;
  width: ${props => props.scale * 20}px;
  height: 20px;
  margin: 0 auto;
`;

class DriverSafetyTable extends Component {
  // generate random width for placeholders
  generatePlaceholder = () => {
    const randomNumber = Math.floor(Math.random() * 2) + 1;
    return <PlaceholderValue scale={randomNumber}>{" "}</PlaceholderValue>;
  };

  // get the merged column value
  getColumnElement = htmlValue => {
    return (
      <ClickElementContent>
        <div dangerouslySetInnerHTML={this.getMergedHeader(htmlValue)} />
        <NitroIcon name="arrow-right" size={8} />
      </ClickElementContent>
    );
  };

  getMergedHeader = value => {
    return { __html: value };
  };

  // Can be moved to dataTransformers once the structure is confirmed
  transformDriverSafeData = (telematicsAvailable, data) => {
    let headers = [];
    let rowObj = [];
    let updateDetails;
    let mockTeleMatics;

    const dataStore = data.slice(0); //duplicate array
    dataStore.map((item, index) => {
      updateDetails = [];
      const details = item.Details;
      const driverSuspended = details[0].PotentialSuspension;

      let LicenseReview = {};
      let Accidents = {};
      LicenseReview.Title = "";
      LicenseReview.Value = "";
      LicenseReview.DriverID = details[0].DriverId;
      Accidents.Title = "";
      Accidents.Value = "";
      Accidents.DriverID = details[0].DriverId;
      details.map((item, j) => {
        switch (item.Groupname) {
          case "LicenseReview":
            LicenseReview.Title = `${LicenseReview.Title}<span>${item.Title}</span>`;
            LicenseReview.Value = `${LicenseReview.Value}<span class=${driverSuspended ? "negative" : ""}>${item.Value}</span>`;
            LicenseReview.Merged = true;
            LicenseReview.Groupname = "LicenseReview";
            break;
          case "Accidents":
            Accidents.Title = `${Accidents.Title} <span>${item.Title}</span>`;
            Accidents.Value = `${Accidents.Value} <span>${item.Value}</span>`;
            Accidents.Merged = true;
            Accidents.Groupname = "Accidents";
            break;
          default:
            return null;
        }
      });
      details.forEach(function(item) {
        if (
          item.Groupname === "Accidents" ||
          item.Groupname === "LicenseReview" 
        )
          return;
        else {
          updateDetails.push(item);
        }
      });

      if (!telematicsAvailable) {
        mockTeleMatics = [];        
      }

      updateDetails.splice(1, 0, LicenseReview);
      if (!telematicsAvailable) updateDetails.splice(2, 0, ...mockTeleMatics);
      updateDetails.splice(updateDetails.length, 0, Accidents);
      rowObj.push(updateDetails);
    });
    headers = rowObj[0].map((item, k) => {
      return {
        title: item.Title,
        group: item.Groupname,
        merged: item.Merged
      };
    });
    return {
      tableHeaders: headers,
      tableBody: rowObj
    };
  };

  sideOpenDetails = (groupName, driverId) => {
    let filters = {};
    filters['categoryFilter'] = groupName;
    filters['FilterKeyId'] = driverId;
    this.props.openDetails(filters);
  };

  render() {
    const { data, telematicsAvailable } = this.props;
    const transformData = this.transformDriverSafeData(
      telematicsAvailable,
      data
    );

    return (
      <TableOverflowWrapper>
        <TableContainer>
          <TableView>
            <TableHead ref="fixedTableHeader">
              <TableRow>
                {transformData.tableHeaders.map((item, index) => {
                  const headerVariant = item.group === "TelematicsData" //different color theme for telematics data
                    ? "primary"
                    : "secondary";
                  const disabledHeader =
                    item.group === "TelematicsData" && !telematicsAvailable;
                  {
                    return (
                      <TableHeader
                        variant={headerVariant}
                        key={index}
                        fixed={index === 0}
                        merged={item.merged}
                        disabled={disabledHeader}
                      >
                        {!item.merged && item.title}
                        {item.merged &&
                          <div
                            dangerouslySetInnerHTML={this.getMergedHeader(
                              item.title
                            )}
                          />}

                      </TableHeader>
                    );
                  }
                })}
              </TableRow>
            </TableHead>
            <TableBody ref="fixedTableBody">

              {transformData.tableBody.map((item, index) => {
                return (
                  <TableBodyRow key={index}>
                    {item.map((colItem, i) => {
                      {
                        {
                          return (
                            <TableColumn
                              key={i}
                              fixed={i === 0}
                              merged={colItem.Merged}
                            >
                              {i === 0 &&
                                <DriverListItem
                                  data={colItem}
                                  index={index}
                                  tableItem
                                  selected={false}
                                  disableHoverStyle
                                />}
                              {colItem.Merged &&
                                <ClickableElement onClick={() => { this.sideOpenDetails(colItem.Groupname, colItem.DriverID) }}>
                                  {this.getColumnElement(colItem.Value)}
                                </ClickableElement>}
                              {!telematicsAvailable &&
                                colItem.Groupname === "TelematicsData" &&
                                <section>{this.generatePlaceholder()}</section>}
                              {(!colItem.Merged && this.props.telematicsAvailable) && colItem.Value}

                            </TableColumn>
                          );
                        }
                      }
                    })}
                  </TableBodyRow>
                );
              })}
            </TableBody>
          </TableView>
        </TableContainer>
      </TableOverflowWrapper>
    );
  }
}

DriverSafetyTable.propTypes = {
  telematicsAvailable: PropTypes.bool,
  data: PropTypes.array.isRequired,
  openDetails: PropTypes.func,
  sideOpenDetails: PropTypes.func
};

export default DriverSafetyTable;



// WEBPACK FOOTER //
// ./src/features/insights/components/driverSafety/components/DriverSafetyTable.js